const industryManagement = () => import('@/pages/industry/index')
const industryList = () => import('@/pages/industry/list')
const industryAddManagement = () => import('@/pages/industry/operation/index')

export default [
  {
    path: '/industry-management',
    component: industryManagement,
    name: 'industryManagement',
    meta: [
      {
        name: '产业管理',
        url: ''
      }
    ],
    children: [
      {
        path: '',
        component: industryList,
        name: 'industryList',
        meta: [
          {
            name: '产业管理',
            url: '/industry-management'
          },
          {
            name: '产业列表',
            url: '/industry-management',
            noCache: true
          }
        ]
      },
      {
        path: 'add',
        component: industryAddManagement,
        name: 'industryAddManagement',
        meta: [
          {
            name: '产业管理',
            url: '/industry-management'
          }, {
            name: '产业列表',
            url: '/industry-management'
          },
          {
            name: '新增产业',
            url: 'industry-management/add',
            noCache: true
          }
        ]
      },
      {
        path: 'edit/:id',
        component: industryAddManagement,
        name: 'industryAddManagement',
        meta: [{
          name: '产业管理',
          url: '/industry-management'
        }, {
          name: '产业列表',
          url: '/industry-management'
        },
        {
          name: '编辑产业',
          url: 'industry-management/edit',
          noCache: true
        }
        ]
      },
    ]
  }
]
